<template>
    <div class="h-screen flex items-center justify-center px-4">
        <AuthCard :title="title" :description="error.status?.toString()">
            <p class="text-center overflow-y-auto wrap-anywhere max-h-100">{{ description }}</p>
            <UButton block color="primary" @click="handleError">Go to the homepage</UButton>
            <UButton v-if="userSession.isAuthenticated" block color="neutral" variant="outline" @click="logout">Sign Out</UButton>
        </AuthCard>
    </div>
</template>

<script setup lang="ts">
    import AuthCard from './pages/(auth)/components/AuthCard.vue';

    import type { NuxtError } from '#app';

    const props = defineProps<{
        error: NuxtError;
    }>();

    const userSession = useUserSessionStore();
    const auth = useAuth();

    const title = computed(() => {
        return props.error.statusText || 'Server Error';
    });

    const description = computed(() => {
        // data can be an array, a string or an JSON
        if (props.error.data) {
            if (isStringArray(props.error.data)) return props.error.data[0];

            if (typeof props.error.data === 'string') {
                try {
                    // If JSON, ignore it
                    JSON.parse(props.error.data);
                } catch {
                    // Restricting to dev as may contain sensiitive info
                    if (import.meta.dev) return props.error.data;
                }
            }
        }

        if (props.error.status === 401) return 'You are not authorized to access this page.';

        if (props.error.status === 404) return 'This page is not found.';

        return props.error.statusText || props.error.message;
    });

    function handleError() {
        clearError({ redirect: '/' });
    }

    async function logout() {
        await auth.signOut();
        clearError();
    }
</script>
